const apiRoutes = {
  authorities: "/authorities",
  counties: "/counties",
  register: "/user/register",
  login: "/user/login",
  workload: "/get/workload",
  getAllUsers: "/users",
  user: "/user"
}

export {
  apiRoutes,
}